import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"
import _imports_0 from '@/assets/filter.svg'


const _hoisted_1 = { class: "pt-3 px-5 pb-5 page-fill" }
const _hoisted_2 = { class: "mb-2 flex-shrink-0" }
const _hoisted_3 = { class: "items-center justify-between flex flex-shrink-0" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "flex flex-col flex-1 min-h-0 overflow-hidden" }
const _hoisted_6 = { class: "mt-5 table-section min-h-0 cr-table-hug" }
const _hoisted_7 = { class: "tableCornerRadius bg-white table-card-shell mapping-inline-table" }
const _hoisted_8 = {
  class: "table-header-wrap",
  ref: "headerWrap"
}
const _hoisted_9 = { class: "table-header-row" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 5 }
const _hoisted_17 = { key: 6 }
const _hoisted_18 = { key: 7 }
const _hoisted_19 = {
  key: 8,
  class: "flex items-center"
}
const _hoisted_20 = ["onMousedown"]
const _hoisted_21 = {
  key: 0,
  class: "table-filter-row"
}
const _hoisted_22 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  key: 1,
  class: "flex justify-center items-center"
}
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["value"]
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = {
  key: 3,
  class: "flex"
}
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_35 = {
  class: "relative h-5",
  colspan: 8
}
const _hoisted_36 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_37 = {
  key: 1,
  class: "empty"
}
const _hoisted_38 = { class: "cursor-pointer rowHeight" }
const _hoisted_39 = ["colspan"]
const _hoisted_40 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 3 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title flex items-center" }, [
        _createElementVNode("h1", null, "Compliance Review")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass(["flex", 'filterButton']),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "filterIcon"
          }, null, -1),
          _createTextVNode(" Filters ")
        ]))
      ])
    ]),
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mt-5 flex-shrink-0" }, [
      _createElementVNode("p", { class: "headerText" }, " Manage evidence collection tasks related to compliance reviews. Assign, track, and upload supporting documents to demonstrate control effectiveness and maintain audit readiness across your organization. ")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "table-container table-container-fit cr-table-x-scroll",
            style: _normalizeStyle({ '--cr-table-width': _ctx.crTableWidth })
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", {
                class: "table-fit-card table-header-table",
                style: _normalizeStyle(_ctx.tableResizeStyle)
              }, [
                _createElementVNode("colgroup", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                    return (_openBlock(), _createElementBlock("col", {
                      key: 'h-'+column,
                      style: _normalizeStyle(_ctx.columnStyle(column))
                    }, null, 4))
                  }), 128))
                ]),
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                      return (_openBlock(), _createElementBlock("th", {
                        scope: "col",
                        key: column,
                        class: _normalizeClass(["bg-white th1 cursor-pointer capitalize resizable-th", _ctx.getColumnHeadWidth(column)]),
                        style: _normalizeStyle(_ctx.columnStyle(column)),
                        onClick: ($event: any) => (_ctx.onHeaderClick(column))
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex", column=='statusCode' || column == 'dueDate'? 'justify-center':''])
                        }, [
                          (column == 'taskId')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[4] || (_cache[4] = [
                                _createElementVNode("div", null, _toDisplayString('ID'), -1)
                              ])))
                            : (column == 'clientUniqueId')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[5] || (_cache[5] = [
                                  _createElementVNode("div", null, _toDisplayString('CID'), -1)
                                ])))
                              : (column == 'controlTitle')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[6] || (_cache[6] = [
                                    _createElementVNode("div", null, _toDisplayString('Title'), -1)
                                  ])))
                                : (column == 'departments')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[7] || (_cache[7] = [
                                      _createElementVNode("div", null, _toDisplayString('Team'), -1)
                                    ])))
                                  : (column == 'entity')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[8] || (_cache[8] = [
                                        _createElementVNode("div", null, _toDisplayString('Location'), -1)
                                      ])))
                                    : (column == 'tier')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[9] || (_cache[9] = [
                                          _createElementVNode("div", null, _toDisplayString('Tier'), -1)
                                        ])))
                                      : (column == 'tierTitle')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[10] || (_cache[10] = [
                                            _createElementVNode("div", null, _toDisplayString('Scope'), -1)
                                          ])))
                                        : (column == 'dueDate')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[11] || (_cache[11] = [
                                              _createElementVNode("div", null, _toDisplayString('Due Date'), -1)
                                            ])))
                                          : (column == 'statusCode')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _cache[12] || (_cache[12] = [
                                                _createElementVNode("div", null, _toDisplayString('Status'), -1)
                                              ])))
                                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                          }, null, 2)
                        ], 2),
                        _createElementVNode("span", {
                          class: "column-resize-handle",
                          onMousedown: _withModifiers(($event: any) => (_ctx.startColumnResize($event, column)), ["stop","prevent"])
                        }, null, 40, _hoisted_20)
                      ], 14, _hoisted_10))
                    }), 128))
                  ]),
                  (_ctx.showFilters)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (name) => {
                          return (_openBlock(), _createElementBlock("td", {
                            class: "bg-white",
                            key: name,
                            style: _normalizeStyle(_ctx.columnStyle(name))
                          }, [
                            (name == 'statusCode')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                  _withDirectives(_createElementVNode("select", {
                                    class: _normalizeClass(_ctx.filterDummy[name]==null? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'),
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                  }, [
                                    _createElementVNode("option", {
                                      value: _ctx.filterDummy.name,
                                      selected: "",
                                      hidden: "",
                                      disabled: ""
                                    }, "Select", 8, _hoisted_24),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statuses, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: option.id,
                                        value: option.id
                                      }, _toDisplayString(option.label), 9, _hoisted_25))
                                    }), 128))
                                  ], 10, _hoisted_23), [
                                    [_vModelSelect, _ctx.filterDummy[name]]
                                  ])
                                ]))
                              : (name == 'tier')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _withDirectives(_createElementVNode("select", {
                                      class: _normalizeClass(_ctx.filterDummy[name]==null? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'),
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                    }, [
                                      _createElementVNode("option", {
                                        value: _ctx.filterDummy.name,
                                        selected: "",
                                        hidden: "",
                                        disabled: ""
                                      }, "Select", 8, _hoisted_28),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tierLevel, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          class: "optionColors",
                                          key: option.id,
                                          value: option.id
                                        }, _toDisplayString(option.value), 9, _hoisted_29))
                                      }), 128))
                                    ], 10, _hoisted_27), [
                                      [_vModelSelect, _ctx.filterDummy[name]]
                                    ])
                                  ]))
                                : (name == 'clientuniqueId')
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 2,
                                      type: "text",
                                      class: "inputboxstylingForControlID",
                                      placeholder: "Search",
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                    }, null, 8, _hoisted_30)), [
                                      [_vModelText, _ctx.filterDummy[name]]
                                    ])
                                  : (name=='dueDate')
                                    ? (_openBlock(), _createElementBlock("input", _hoisted_31))
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 4,
                                        type: "text",
                                        class: "searchForInputBoxStyling",
                                        placeholder: "Search",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                      }, null, 8, _hoisted_32)), [
                                        [_vModelText, _ctx.filterDummy[name]]
                                      ])
                          ], 4))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 4)
            ], 512),
            _createElementVNode("div", {
              class: "table-body-scroll",
              ref: "bodyScroll",
              onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.syncTableXScroll && _ctx.syncTableXScroll(...args)))
            }, [
              _createElementVNode("table", {
                class: "table-fit-card",
                style: _normalizeStyle(_ctx.tableResizeStyle)
              }, [
                _createElementVNode("colgroup", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                    return (_openBlock(), _createElementBlock("col", {
                      key: 'b-'+column,
                      style: _normalizeStyle(_ctx.columnStyle(column))
                    }, null, 4))
                  }), 128))
                ]),
                (_ctx.dataLoading == true)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_33, [
                      _createElementVNode("tr", _hoisted_34, [
                        _createElementVNode("td", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_dots_loader)
                          ])
                        ])
                      ])
                    ]))
                  : (_ctx.sortedData.length == 0)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_37, [
                        _createElementVNode("tr", _hoisted_38, [
                          _createElementVNode("td", {
                            class: "relative h-10",
                            colspan: _ctx.columnNames.length
                          }, _cache[13] || (_cache[13] = [
                            _createElementVNode("div", { class: "flex justify-center items-center" }, [
                              _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                            ], -1)
                          ]), 8, _hoisted_39)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_40, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row._id || index,
                            class: "rowHeight hoverEffectForCompleteRow",
                            onClick: ($event: any) => (_ctx.goToControlTaskEdit(row))
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: presentColumn,
                                class: _normalizeClass(["cursor-pointer relative", _ctx.getColumnHeadWidth(presentColumn)]),
                                style: _normalizeStyle(_ctx.columnStyle(presentColumn))
                              }, [
                                (presentColumn == 'statusCode')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-32 ml-1.5", _ctx.colorComplianceBg(row.statusCode)])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(_ctx.colorComplianceText(row.statusCode))
                                        }, _toDisplayString(_ctx.statuses.find((l) => {
                                                    return l.id == row[presentColumn];
                                                })?.label|| 'N/A'), 3)
                                      ], 2)
                                    ]))
                                  : (presentColumn=='tier')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        _createElementVNode("div", null, _toDisplayString(_ctx.tierLevel.find((l) => {
                                                    return l.id == row[presentColumn];
                                                })?.value|| 'N/A'), 1)
                                      ]))
                                    : (presentColumn=='dueDate')
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: _normalizeClass(["flex justify-center items-center w-24 rounded h-5", _ctx.shouldStyleDueDate(row) ? _ctx.colorForDueDate(row[presentColumn]) : ''])
                                        }, _toDisplayString(row[presentColumn]), 3))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(row[presentColumn]), 1))
                              ], 6))
                            }), 128))
                          ], 8, _hoisted_41))
                        }), 128))
                      ]))
              ], 4)
            ], 544),
            (_ctx.toolTipActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                ]))
              : _createCommentVNode("", true)
          ], 4),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_pagination, {
              dynamicPagination: _ctx.dynamicPagination,
              onCurrentPageUpdate: _ctx.paginationUpdations,
              sortedData: _ctx.sortedData
            }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
          ])
        ])
      ])
    ])
  ]))
}